<div class="container mx-auto mt-5 px-4">
  <h1 class="text-3xl font-semibold text-center mb-6">Revisar Documento</h1>

  <div class="flex justify-between items-center mb-4">
    <button
      type="button"
      (click)="volver()"
      class="block bg-blue-500 hover:bg-blue-600 text-white font-semibold px-4 py-2 rounded"
    >
      Volver
    </button>
  </div>

  <form [formGroup]="documentoForm">
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <!-- Estado Actual -->
      <div class="form-group">
        <label for="estado_actual" class="block font-semibold mb-1"
          >Estado Actual</label
        >
        <input
          id="estado_actual"
          type="text"
          [value]="currentEstado"
          class="block border border-gray-300 rounded w-full py-2 px-4 bg-gray-50 text-gray-600 cursor-not-allowed"
          readonly
        />
      </div>

      <!-- Desplegable para Cambiar el Estado -->
      <div class="form-group relative">
        <label for="estado" class="block font-semibold mb-1"
          >Cambiar Estado <span class="text-red-500">*</span></label
        >
        <div class="relative">
          <select
            id="estado"
            formControlName="estado"
            class="border border-gray-300 rounded w-full py-2 px-4 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-400"
            (change)="onEstadoChange($event)"
          >
            <option value="" disabled selected>Seleccione un estado...</option>
            <!-- Opción por defecto -->
            <option *ngFor="let estado of estadosCambio" [value]="estado">
              {{ estado }}
            </option>
          </select>
          <div
            class="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none"
          ></div>
        </div>
      </div>

      <!-- Fecha de Subida -->
      <div class="form-group">
        <label for="fecha_subida" class="block font-semibold mb-1"
          >Fecha de Subida</label
        >
        <input
          id="fecha_subida"
          formControlName="fecha_subida"
          type="text"
          class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded bg-gray-50 text-gray-600 cursor-not-allowed"
          readonly
        />
      </div>

      <!-- Link de Archivo -->
      <div class="form-group">
        <label for="link_archivo" class="block font-semibold mb-1"
          >Link de Archivo</label
        >
        <a
          *ngIf="documentoForm.get('link_archivo')?.value"
          [href]="documentoForm.get('link_archivo')?.value"
          target="_blank"
          class="block border border-gray-300 rounded w-full px-3 py-2 hover:bg-gray-100 focus:outline-none focus:ring-2 text-blue-500 focus:ring-blue-400 flex items-center"
        >
          <i class="fas fa-download mr-2"></i>
          Descargar Archivo
        </a>
        <div
          *ngIf="
            documentoForm.get('link_archivo')?.invalid &&
            documentoForm.get('link_archivo')?.touched
          "
          class="text-red-500 text-xs mt-1"
        >
          <small *ngIf="documentoForm.get('link_archivo')?.errors?.['required']"
            >Este campo es obligatorio.</small
          >
          <small
            *ngIf="documentoForm.get('link_archivo')?.errors?.['maxlength']"
            >El link es demasiado largo.</small
          >
        </div>
      </div>

      <!-- Institución -->
      <div class="form-group">
        <label for="institucion" class="block font-semibold mb-1"
          >Institución</label
        >
        <input
          id="institucion"
          formControlName="institucion"
          type="text"
          class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded bg-gray-50 text-gray-600 cursor-not-allowed"
          readonly
        />
      </div>

      <div class="form-group">
        <label for="director" class="block font-medium mb-1">Director</label>
        <input
          id="director"
          formControlName="director"
          type="text"
          class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded bg-gray-50 text-gray-600 cursor-not-allowed"
          readonly
        />
      </div>
    </div>

    <!-- Historial -->
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-6">
      <!-- Historial del Admin -->
      <div>
        <h2 class="text-xl font-semibold mb-3 text-gray-700 border-b pb-2">
          Historial del Admin
        </h2>
        <ul class="bg-gray-100 rounded-md shadow-md p-4">
          <li
            *ngFor="let historial of historialAdmin"
            class="mb-4 p-3 bg-white rounded-lg shadow"
          >
            <div class="flex justify-between items-start">
              <span
                [ngClass]="{
                  'bg-green-500': historial.accion == 'LOGRADO',
                  'bg-blue-500': historial.accion == 'RECTIFICADO',
                  'bg-yellow-500': historial.accion == 'INICIADO',
                  'bg-orange-500': historial.accion == 'OBSERVADO',
                  'bg-gray-500': historial.accion == 'PROCESO'
                }"
                class="text-white px-2 py-1 rounded-full"
                >{{ historial.accion | titlecase }}</span
              >
              <span class="text-sm text-gray-500">{{
                historial.fecha | date : "dd/MM/yyyy HH:mm"
              }}</span>
            </div>
            <p class="mt-1 text-gray-700">{{ historial.observacion }}</p>
            <p class="text-sm text-gray-500 mt-2">
              Por: {{ historial.usuarioNombreCompleto }}
            </p>
          </li>
        </ul>
      </div>

      <!-- Historial de la Institución -->
      <div>
        <h2 class="text-xl font-semibold mb-3 text-gray-700 border-b pb-2">
          Historial de la Institución
        </h2>
        <ul class="bg-gray-100 rounded-md shadow-md p-4">
          <li
            *ngFor="let historial of historialInstitucion"
            class="mb-4 p-3 bg-white rounded-lg shadow"
          >
            <div class="flex justify-between items-start">
              <span
                [ngClass]="{
                  'bg-green-500': historial.accion == 'LOGRADO',
                  'bg-blue-500': historial.accion == 'RECTIFICADO',
                  'bg-yellow-500': historial.accion == 'INICIADO',
                  'bg-orange-500': historial.accion == 'OBSERVADO',
                  'bg-gray-500': historial.accion == 'PROCESO'
                }"
                class="text-white px-2 py-1 rounded-full"
                >{{ historial.accion | titlecase }}</span
              >
              <span class="text-sm text-gray-500">{{
                historial.fecha | date : "dd/MM/yyyy HH:mm"
              }}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </form>
</div>
